
import Home from "./components/home";
import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import App from "./App";
import About from "./components/about";
import Services from "./components/services";
import Contact from "./components/contact";
import Careers from "./components/careers";
import Login from "./components/admin/Login";
import Dashboard from "./components/admin/Dashboard";
import ProtectedRoute from "./components/admin/ProtectedRoute";
import SeoPage from "./components/SeoPage";
import ServicesDirectory from "./components/ServicesDirectory";
import FAQ from "./components/FAQ";
import Reviews from "./components/Reviews";
import Blog from "./components/Blog";
import BlogPost from "./components/BlogPost";
import { HelmetProvider } from 'react-helmet-async'

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

function Routing() {
  return (
    <Router>
      <Routes>

        <Route path="/" element={<App />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="services" element={<Services />} />
          <Route path="contact" element={<Contact />} />
          <Route path="careers" element={<Careers />} />
          <Route path="all-services" element={<ServicesDirectory />} />
          <Route path="faq" element={<FAQ />} />
          <Route path="reviews" element={<Reviews />} />
          <Route path="blog" element={<Blog />} />
          <Route path="blog/:slug" element={<BlogPost />} />
          <Route path=":slug" element={<SeoPage />} />
        </Route>

        {/* Admin routes — outside main layout (no header/footer) */}
        <Route path="/login" element={<Login />} />
        <Route
          path="/dashboard"
          element={<ProtectedRoute><Dashboard /></ProtectedRoute>}
        />

      </Routes>
    </Router>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider> 
    <Routing />
    </HelmetProvider>
  </React.StrictMode>
);



reportWebVitals();